export const environment = {
  cfVideoServer: 'd1meyj1e9ccm5f.cloudfront.net',
  domain: 'coderace.org',
  domainName: 'Code Race',
  imagesServer: 'da1i7sngl7lgg.cloudfront.net',
  localStoragePrefix: 'CR.',
  name: null,
  production: true,
  project: 'cr',
  shortName: 'prod',
  stripeKey: 'pk_live_51PfLXhF0xGSOsPSTRHwsYwRO1mCI5A3iHwnQE7xDPRo3uHwZhlDOSuXocMgLxFUTxjPPBHcORV9PJPhNsQYxX99P001oNGxBEJ',
  urlAppAdminPrefix: 'admin',
  urlAppAmazonScholarshipPrefix: 'amazon',
  urlAppCurriculumPrefix: 'curriculum',
  urlAppHomePrefix: '',
  urlAppLandingPagesPrefix: 'welcome',
  urlAppTrainingPrefix: 'training',
  urlConfirmationPath: 'confirmations',
  urlRoot: 'https://www.coderace.org',
  urlSignOut: 'https://www.coderace.org',
  urlStudentProfilePath: 'profile',
  urlWebServices: 'https://www.coderace.org/be/index.php'
};
